import CustomHeading from "./CustomHeading"
import NotInterestedIcon from '@material-ui/icons/NotInterested';


export const NoDataFound = ({ text }) => {
    return (
        <div style={{ margin: '80px 0px', textAlign: 'center', opacity: '0.3' }}>
            <NotInterestedIcon style={{ fontSize: '100px' }} />
            <CustomHeading heading={text ? text : "No Data Found"} error />
        </div>
    )
}
